export const DEFAULT_PARTNER = {
  firstName: 'Someone',
  lastName: 'Special',
};

export const ACCOUNT_ERROR_MESSAGES = {
  invalidEmail: 'Please enter a correct email address',
  inUseEmail: 'The provided email is in use.',
  invalidPassword: 'Your password must be at least 8 characters long',
  emptyWeddingDetails: 'Please enter your first and last name',
  emptyPartnerWeddingDetails: "Please enter your partner's first and last name",
  invalidWeddingDate: 'Please make sure your wedding date is valid',
  invalidWeddingDetails: 'Please make sure your wedding details are valid.',
};
